var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 9,
    viewBox: "0 0 11 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7403 0.210409C11.0626 0.51292 11.0884 1.03027 10.7979 1.36593L4.3474 8.72956C4.2012 8.89849 3.99407 8.99644 3.77571 8.9999C3.55735 9.00337 3.34746 8.91204 3.19638 8.74783L0.218356 5.47511C-0.0818399 5.14882 -0.0711821 4.63089 0.242161 4.31829C0.555505 4.00569 1.05288 4.01679 1.35307 4.34308L3.74615 6.98001L9.63062 0.270443C9.92112 -0.0652243 10.4179 -0.0921026 10.7403 0.210409Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.91530e91a357af169ac8c4dea8e2ce9a.svg";
export { ForwardRef as ReactComponent };